import ClothCreateContainer from "./ClothCreateContainer"


const ClothCreate = () => {
  return (
    <div className='page-body'>
      <ClothCreateContainer />
    </div>
  )
}

export default ClothCreate